import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bsp-popup" }
const _hoisted_2 = { class: "bsp-header" }
const _hoisted_3 = { class: "bsp-title" }
const _hoisted_4 = { class: "bsp-select-all" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "全选", -1)
const _hoisted_6 = {
  key: 0,
  class: "bsp-selected-count",
  style: {"color":"#e8392a"}
}
const _hoisted_7 = {
  key: 0,
  class: "bsp-loading"
}
const _hoisted_8 = {
  key: 1,
  class: "bsp-list"
}
const _hoisted_9 = { class: "bsp-letter" }
const _hoisted_10 = { class: "bsp-group-items" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "bsp-footer" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "bsp-mask",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('cancel')), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
              _createElementVNode("span", {
                class: "bsp-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", {
                class: "bsp-checkbox-row",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["bsp-checkbox", { checked: _ctx.isAllSelected, partial: _ctx.isPartial }]),
                  style: _normalizeStyle(_ctx.checkboxStyle(_ctx.isAllSelected || _ctx.isPartial))
                }, null, 6),
                _hoisted_5
              ]),
              (_ctx.pending.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "已选 " + _toDisplayString(_ctx.pending.length) + " 个", 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "加载中..."))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedOptions, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.letter,
                      class: "bsp-group-row"
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(group.letter), 1),
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (opt) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: opt.attrCode,
                            class: "bsp-checkbox-row",
                            onClick: ($event: any) => (_ctx.toggleOption(opt))
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["bsp-checkbox", { checked: _ctx.pendingCodes.has(opt.attrCode) }]),
                              style: _normalizeStyle(_ctx.checkboxStyle(_ctx.pendingCodes.has(opt.attrCode)))
                            }, null, 6),
                            _createElementVNode("span", {
                              class: "bsp-opt-name",
                              title: opt.attrName
                            }, _toDisplayString(opt.attrName), 9, _hoisted_12)
                          ], 8, _hoisted_11))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ])),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "bsp-btn-cancel",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
              }, "取消"),
              _createElementVNode("button", {
                class: "bsp-btn-confirm",
                disabled: _ctx.confirmDisabled,
                style: _normalizeStyle(_ctx.confirmBtnStyle),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args)))
              }, "确定", 12, _hoisted_14)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}